import { gql } from '@apollo/client';
import { REPORTING_REQUIREMENT_DETAIL } from '../fragments/reportingRequirement';

export const SET_REPORTING_REPORTER_OVERRIDE = gql`
  mutation setReportingReporterOverride($input: ReportingReporterOverrideInput!) {
    result: setReportingReporterOverride(input: $input) {
      requirement {
        ...reportingRequirementDetail
      }
      periodsCreated
      periodsUpdated
      periodsDeleted
      reporterDatesUpdated
      formUsersAdded
      reportersWithoutDates
    }
  }
  ${REPORTING_REQUIREMENT_DETAIL}
`;
